import { COOKIES } from '@sravni/utils/lib/consts';
const UTMZ_MAX_AGE = 183 * 24 * 60 * 60 * 1000;
const NONE = '(none)';
const NOT_SET = '(not set)';
export const UTM_MARKS = {
    SOURCE: 'utm_source',
    CAMPAIGN: 'utm_campaign',
    MEDIUM: 'utm_medium',
    TERM: 'utm_term',
    CONTENT: 'utm_content',
};
export const UTM_COOKIE_MAP = {
    [UTM_MARKS.SOURCE]: 'utmcsr',
    [UTM_MARKS.CAMPAIGN]: 'utmccn',
    [UTM_MARKS.MEDIUM]: 'utmcmd',
    [UTM_MARKS.TERM]: 'utmctr',
    [UTM_MARKS.CONTENT]: 'utmcct',
};
export const FB_MAP = {
    utm_source: 'UtmSource',
    utm_medium: 'UtmMedium',
    utm_campaign: 'UtmCampaign',
    utm_term: 'UtmTerm',
    utm_content: 'UtmContent',
};
export const DEFAULT_SET = new Set([
    UTM_MARKS.SOURCE,
    UTM_MARKS.CAMPAIGN,
    UTM_MARKS.MEDIUM,
    UTM_MARKS.TERM,
    UTM_MARKS.CONTENT,
]);
const BLACK_LIST = new Set([
    'my.sravni.ru',
    'sravni.ru',
    'sravni-team.ru',
    'securepay.tcsbank.ru',
    'securepay.tinkoff.ru',
    'googleads.g.doubleclick.net',
    'yabs.yandex.ru',
    'tpc.googlesyndication.com',
    'e-commerce.raiffeisen.ru',
    'securepayments.sberbank.ru',
    'acs.alfabank.ru',
    'secure.tinkoff.ru',
]);
export const PRESET_KEYS = {
    GOOGLE: 'google',
    YANDEX: 'yandex',
    FACEBOOK: 'facebook',
    DEFAULT: 'default',
    EMPTY: 'empty',
};
export const PRESETS = {
    [PRESET_KEYS.GOOGLE]: {
        [UTM_MARKS.SOURCE]: 'google',
        [UTM_MARKS.MEDIUM]: 'cpc',
    },
    [PRESET_KEYS.YANDEX]: {
        [UTM_MARKS.SOURCE]: 'yandex',
        [UTM_MARKS.MEDIUM]: 'cpc',
    },
    [PRESET_KEYS.FACEBOOK]: {
        [UTM_MARKS.SOURCE]: 'facebook',
        [UTM_MARKS.MEDIUM]: 'referral',
    },
    [PRESET_KEYS.DEFAULT]: {
        [UTM_MARKS.SOURCE]: '(direct)',
        [UTM_MARKS.MEDIUM]: NONE,
        [UTM_MARKS.CAMPAIGN]: NOT_SET,
    },
    // Set all to not set value
    [PRESET_KEYS.EMPTY]: Array.from(DEFAULT_SET).reduce((output, key) => {
        if (key === UTM_MARKS.MEDIUM) {
            output[key] = NONE;
        }
        else {
            output[key] = NOT_SET;
        }
        return output;
    }, {}),
};
const ORGANICS = {
    GOOGLE: 'google',
    YANDEX: 'yandex',
    YAHOO: 'yahoo',
    BING: 'bing',
    RAMBLER: 'rambler',
    ZAPMETA: 'zapmeta',
    MAIL: 'go.mail',
    NIGMA: 'nigma',
    MSN: 'msn.com',
    DUCKDUCKGO: 'duckduckgo',
    SEARCH_1AND1: 'search.1and1',
    ASK: 'ask.com',
    TUT: 'tut.by',
    POISK_NGS: 'poisk.ngs',
    SEARCH_I_UA: 'search.i.ua',
    META_UA: 'meta.ua',
    QIP: 'search.qip',
    SPUTNIK: 'sputnik',
};
export const ORGANICS_SEARCH_KEYS = {
    // q
    [ORGANICS.SPUTNIK]: 'q',
    [ORGANICS.QIP]: 'q',
    [ORGANICS.META_UA]: 'q',
    [ORGANICS.POISK_NGS]: 'q',
    [ORGANICS.GOOGLE]: 'q',
    [ORGANICS.MAIL]: 'q',
    [ORGANICS.BING]: 'q',
    [ORGANICS.ZAPMETA]: 'q',
    [ORGANICS.DUCKDUCKGO]: 'q',
    [ORGANICS.SEARCH_1AND1]: 'q',
    [ORGANICS.ASK]: 'q',
    [ORGANICS.SEARCH_I_UA]: 'q',
    // text
    [ORGANICS.YANDEX]: 'text',
    // query
    [ORGANICS.RAMBLER]: 'query',
    [ORGANICS.TUT]: 'query',
    // p
    [ORGANICS.YAHOO]: 'p',
};
/**
 * Utmz
 */
export default class UTMZ {
    static KEY = COOKIES.UTMZ;
    static NOT_SET = NOT_SET;
    static NONE = NONE;
    static organics = Object.values(ORGANICS);
    static DEFAULT_SET = DEFAULT_SET;
    static getDomain(url) {
        const matches = url.match(/^(?:https?:\/\/)?(?:www\.)?([^:/\n?]+)/i);
        return matches?.[1] || '';
    }
    static get(cookies) {
        return this.getFromCookieString(decodeURIComponent(cookies.get(this.KEY) || ''));
    }
    static getQueryObjectFromUrl(url) {
        if (!url) {
            return {};
        }
        // get query
        return (url.split('?')[1] || '').split('&').reduce((out, part) => {
            const [name, value] = part.split('=');
            out[name] = value;
            return out;
        }, {});
    }
    static getFromReferrer(url) {
        const domain = this.getDomain(url);
        const organic = this.organics.find((item) => domain.includes(item));
        let output = {};
        if (!organic) {
            output = {
                [UTM_MARKS.SOURCE]: domain,
                [UTM_MARKS.MEDIUM]: 'referral',
            };
        }
        else {
            output = {
                [UTM_MARKS.SOURCE]: organic,
                [UTM_MARKS.MEDIUM]: 'organic',
            };
            const searchKey = ORGANICS_SEARCH_KEYS[organic];
            if (searchKey) {
                const query = this.getQueryObjectFromUrl(url);
                const search = query[searchKey];
                if (search) {
                    output[UTM_MARKS.TERM] = search;
                }
            }
        }
        return output;
    }
    static getFormbuilderFormat(cookies) {
        const data = this.get(cookies);
        return Object.keys(data).reduce((output, key) => {
            output[FB_MAP[key] || key] = data[key];
            return output;
        }, {});
    }
    static createCookieString(params) {
        const utm = {
            ...this.getPreset(PRESET_KEYS.EMPTY),
            ...params,
        };
        // make string like:
        // utmcsr=trigger|utmccn=1330_osago_resale_30days|utmcmd=email|utmctr=(not set)|utmcct=(not set)
        return Object.keys(utm)
            .reduce((acc, key) => [...acc, `${UTM_COOKIE_MAP[key]}=${utm[key]}`], [])
            .join('|');
    }
    static getPreset(presetName) {
        return {
            ...PRESETS[presetName],
        };
    }
    static getProviderPreset(url) {
        if (!url) {
            return;
        }
        const { 
        // google
        gclid, gclsrc, 
        // yandex
        yclid, 
        // facebook
        fbclid, } = this.getQueryObjectFromUrl(url);
        if (gclid || gclsrc) {
            return this.getPreset(PRESET_KEYS.GOOGLE);
        }
        if (yclid) {
            return this.getPreset(PRESET_KEYS.YANDEX);
        }
        if (fbclid) {
            return this.getPreset(PRESET_KEYS.FACEBOOK);
        }
    }
    static prepareCookieValue(data) {
        const { referrer, url, utmz, host } = data;
        // If we have valid url with main marks
        if (this.validateUrl(url)) {
            // Generate value based on new marks
            return this.getFromUrl(url);
        }
        // try to get provider in link
        const provider = this.getProviderPreset(url);
        // check that we come from one of provider
        if (provider) {
            return provider;
        }
        if (this.validateReferer(referrer, host)) {
            // Generate from referer
            return this.getFromReferrer(referrer);
        }
        if (Object.keys(utmz).length === 0) {
            // Or if we have no value
            // set default
            return this.getPreset(PRESET_KEYS.DEFAULT);
        }
    }
    static setCookie({ url, headers, cookies, setter, }) {
        const { host, referer: referrer } = headers;
        const value = this.prepareCookieValue({
            url,
            host,
            referrer,
            utmz: this.get(cookies),
        });
        // If value defined
        if (value) {
            // set with this rules
            setter(this.KEY, this.createCookieString(value), {
                path: '/',
                maxAge: UTMZ_MAX_AGE,
                httpOnly: false,
            });
        }
    }
    static getFromUrl(url) {
        const output = {
            ...PRESETS[PRESET_KEYS.EMPTY],
        };
        // if url exist
        if (url) {
            // get query
            const query = this.getQueryObjectFromUrl(url);
            // for all in set
            this.DEFAULT_SET.forEach((name) => {
                if (query[name]) {
                    output[name] = query[name];
                }
            });
        }
        return output;
    }
    static getFromCookieString(utmzString) {
        const output = {};
        if (utmzString) {
            const storedObject = utmzString.split('|').reduce((o, group) => {
                const [name, value] = group.split('=');
                o[name] = value;
                return o;
            }, {});
            this.DEFAULT_SET.forEach((name) => {
                const value = storedObject[UTM_COOKIE_MAP[name]];
                if (value) {
                    output[name] = value;
                }
            });
        }
        return output;
    }
    static validateUrl(url) {
        if (url) {
            return [UTM_MARKS.SOURCE, UTM_MARKS.CAMPAIGN, UTM_MARKS.MEDIUM, UTM_MARKS.CONTENT, UTM_MARKS.TERM].some((mark) => url.includes(mark));
        }
        return false;
    }
    static validateReferer(referrer, host) {
        if (referrer) {
            const referrerDomain = this.getDomain(referrer);
            const hostDomain = this.getDomain(host);
            const isWhite = !BLACK_LIST.has(referrerDomain);
            return Boolean(referrerDomain) && hostDomain !== referrerDomain && isWhite;
        }
        return false;
    }
}
